<template>
  <div class='checkbox' :class="{checked: modelValue}">
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        :class="{checked: modelValue}"
      >
        <path
          fill="none"
          stroke="black"
          stroke-width="3"
          d="M1.73 12.91l6.37 6.37L22.79 4.59"
          class='check'
        ></path>
      </svg>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'Checkbox',
    props: ['modelValue'],
    components: {
    },
    data(){
        return {
        }
    },

  } //ends export default
</script>

<style lang="scss" scoped>

.checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 5px;
    padding-left: 0px;
    user-select: none;

    svg {
      border: 1px solid gray;;
      height: 20px;
      width: 20px;
      display: inline-block;
      border-radius: 5px;

      path, text {
        transition: transform 0.1s ease-in 25ms;
        transform-origin: bottom left;
        transform: scale(0);
      }

      &.checked .check{
        transform: scale(1);
      }

      &.crossed .cross{
        transform: scale(1);
      }
    }

    .label {
      font-weight: bold;
      padding-left: 10px;

    }
  } //ends .checkbox
</style>
